import React from 'react';
import { Link } from '../../Elements/Link';
import JsonLdBreadcrumb from 'components/Utils/JsonLD/JsonLdBreadcrumb';

export const Breadcrumb = ({
  links,
  withJsonLd,
  hideLast,
}: {
  links: any;
  withJsonLd?: boolean;
  hideLast?: boolean;
}) => (
  <>
    {withJsonLd === true && <JsonLdBreadcrumb links={links} />}
    {links.map((link, key) =>
      link && ((hideLast && key + 1 !== links.length) || !hideLast) ? (
        <div className='flex mr-2 items-center hover:underline'>
          <Link
            {...link}
            title='Go back to category page'
            type='Page'
            icon={null}
            label={{
              ...link?.label,
              icon: null,
              size: 'base',
              truncate: true,
            }}
          />
          <svg
            className='flex-shrink-0 h-4 w-4 text-gray-300'
            xmlns='http://www.w3.org/2000/svg'
            fill='currentColor'
            viewBox='0 0 15 15'
            aria-hidden='true'>
            <path d='M5.555 17.776l8-16 .894.448-8 16-.894-.448z' />
          </svg>
        </div>
      ) : null
    )}
  </>
);
